<template>
  <div
    :class="DS_FEATURE_HINT_CLASSES.Media"
    data-cy="ds-feature-hint__media"
  >
    <video
      v-if="isVideo"
      :class="DS_FEATURE_HINT_CLASSES.MediaContent"
      :src="props.src"
      :autoplay="!prefersReducedMotion"
      muted
      loop
      playsinline
      :aria-label="props.alt"
      data-cy="ds-feature-hint__video"
    />
    <img
      v-else
      :class="DS_FEATURE_HINT_CLASSES.MediaContent"
      :src="props.src"
      :alt="props.alt ?? ''"
      data-cy="ds-feature-hint__image"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { usePreferredReducedMotion } from "@vueuse/core";
import type { DSFeatureHintMediaProps } from "@/src/design_system/feedback/feature_hint/types/mediaProps";
import { DS_FEATURE_HINT_CLASSES } from "@/src/design_system/feedback/feature_hint/constants/classes";
import { isVideoMedia } from "@/src/design_system/feedback/feature_hint/utils/media";

const props = withDefaults(defineProps<DSFeatureHintMediaProps>(), { alt: undefined });

const reducedMotionPreference = usePreferredReducedMotion();
const prefersReducedMotion = computed(() => reducedMotionPreference.value === "reduce");
const isVideo = computed(() => isVideoMedia(props.src));
</script>
